import * as actions from './actions';
import * as mutations from './mutations';
import state from './state';

const bsa = {
   namespaced: true,
   mutations,
   actions,
   state,
};

export default bsa;
